// this is an autogenerated file from App/Account/Content/Tasks/New/TaskOverlay/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_TaskOverlay_Content(
  $patient_id: uuid!
  $document_template_id: uuid!
  $recipient_id: uuid
  $postal_address_id: uuid
) {
  tasks_generate_letter(
    document_template_id: $document_template_id
    patient_id: $patient_id
    recipient_id: $recipient_id
    postal_address_id: $postal_address_id
  ) {
    documentNodeId
  }
}

`